import type { StyleLayer } from './utils/types'

export const layers_pois_education: StyleLayer[] = [
  {
    id: 'education-classification-edu-names',
    type: 'symbol',
    filter: ['has', 'formalEducation'],
    minzoom: 11,
    layout: {
      'text-anchor': 'top',
      'text-field': ['to-string', ['get', 'name']],
      'text-font': ['Open Sans Regular', 'Arial Unicode MS Regular'],
      'text-offset': [0, 0.5],
      'text-size': ['interpolate', ['linear'], ['zoom'], 13, 9, 15, 11],
    },
    paint: {
      'text-color': [
        'match',
        ['get', 'formalEducation'],
        ['college', 'school'],
        '#0e53b4',
        ['kindergarten', 'childcare'],
        '#157784',
        ['university', 'research_institute'],
        '#7c18f7',
        '#000000',
      ],
      'text-halo-color': 'hsla(0, 6%, 97%, 0.91)',
      'text-halo-width': 1,
      'text-opacity': ['interpolate', ['linear'], ['zoom'], 13.9, 0, 14, 0.7],
      'text-translate': [0, 8],
      'text-translate-anchor': 'viewport',
    },
  },
  {
    id: 'education-classification-edu',
    type: 'circle',
    filter: ['has', 'formalEducation'],
    minzoom: 11,
    paint: {
      'circle-color': [
        'match',
        ['get', 'formalEducation'],
        ['childcare', 'kindergarten'],
        '#19a1b3',
        ['college', 'school'],
        '#1269e2',
        ['university', 'research_institute'],
        '#b070ff',
        '#000000',
      ],
      'circle-opacity': ['interpolate', ['linear'], ['zoom'], 9, 0, 9.2, 1],
      'circle-radius': [
        'interpolate',
        ['linear'],
        ['zoom'],
        11,
        ['match', ['get', 'amenity'], ['kindergarten', 'childcare'], 1.3, 1.8],
        15,
        ['match', ['get', 'amenity'], ['kindergarten', 'childcare'], 5, 7],
      ],
      'circle-stroke-color': '#ffffff',
      'circle-stroke-opacity': ['interpolate', ['linear'], ['zoom'], 10, 0, 11, 1],
      'circle-stroke-width': ['interpolate', ['linear'], ['zoom'], 10, 0.8, 12, 1.5],
      'circle-translate': [0, 0],
      'circle-translate-anchor': 'viewport',
    },
  },
  {
    id: 'pois-heat copy',
    type: 'heatmap',
    filter: ['has', 'formalEducation'],
    maxzoom: 11.1,
    paint: {
      'heatmap-color': [
        'interpolate',
        ['linear'],
        ['heatmap-density'],
        0,
        'rgba(18, 105, 226, 0)',
        0.1,
        'rgba(18, 105, 226, 0.1)',
        0.3,
        'rgba(18, 105, 226, 0.4)',
        0.5,
        'rgba(18, 105, 226, 0.6)',
        0.7,
        'rgba(18, 105, 226, 0.7)',
        1,
        '#1269e2',
      ],
      'heatmap-opacity': ['interpolate', ['linear'], ['zoom'], 7.5, 0, 7.7, 1, 11, 1, 11.1, 0],
      'heatmap-radius': ['interpolate', ['linear'], ['zoom'], 10, 3, 12, 7],
      'heatmap-weight': 3,
    },
  },
]
